import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "5", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "22", y2: "8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 12H2a10 10 0 0 0 20 0h-3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Anchor";
const Anchor = memo(themed(Icon));
export {
  Anchor
};
//# sourceMappingURL=anchor.js.map
